type IdentifierType = {
  caseIndex: number;
  iteration: number;
  label: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
} & Record<string, any>;

export enum QuickAdjustmentAction {
  CloseLeg = 'CloseLeg',
  ExecuteLeg = 'ExecuteLeg',
  MoveToCost = 'MoveToCost',
  OpenCase = 'OpenCase',
  CloseCase = 'CloseCase',
}

export type QuickAdjustmentConfig = {
  trigger: string;
  action: QuickAdjustmentAction;
  targets: Array<string | number>;
};

type IntentUIConfig = {
  quickAdjustments: QuickAdjustmentConfig[];
};

export type Intent = {
  type: string;
  identifier: IdentifierType;
  uiConfigs: IntentUIConfig;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
} & Record<string, any>;
